import grispiApiBasic from '../../apis/grispiApiBasic';

export const tenantIdExistsService = async (tenantId: string): Promise<any> => {
    let isTenantIdExists = false;
    try {
        await grispiApiBasic.get(`/tenants/${tenantId}/exists`);
        isTenantIdExists = true;
    } catch (error: any) {
        if (error?.code === 'ECONNREFUSED') throw error;
        if (error?.code === 'ERR_NETWORK') throw error;
        if (error?.response?.status === 500) throw error;

        console.warn(`tenantId: '${tenantId}' not exists. `, error.message);
        isTenantIdExists = false;
    }

    return isTenantIdExists;
};
